import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQChd2os4JMzS7ol9jOruKkBSfp93oPqEWQiKJqS+UR3JeGUGYyRIlS/sOqHZypWFsc0R9+sfSYVaYiJU44mfTAERgEwrNy49LY9RkmeoPlbeSS/02qTMHV7PAjCqd1r46VK5JLOAE8Mr0UX3/1/GBYDojHWOGEpMQ4qNsUMXp5zDwIDAQAB'
const privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAKF3aizgkzNLuiX2M6u4qQFJ+n3eg+oRZCIompL5RHcl4ZQZjJEiVL+w6odnKlYWxzRH36x9JhVpiIlTjiZ9MARGATCs3Lj0tj1GSZ6g+Vt5JL/TapMwdXs8CMKp3WvjpUrkks4ATwyvRRff/X8YFgOiMdY4YSkxDio2xQxennMPAgMBAAECgYBA1V0ptecFQtP06D3pJtWdseHF5rIbK26ElL80YqiOGwTP3c5mfF2BNv2E7vS96pmEMZPrg7jmAiET2xwJ8lxzxhrsGRZg3ObY75tw9o0UBjYqNt1OpM67Aoa2NysI499yXL4AMz8jkrKEGWeVHG2qCGgoeGjS9uSLqeJo2FcN6QJBAOhHuNm0+Ecmpp37qKzLJ6kP5Jdy7clfHRd3b8kxATU01wJkkIcZwYPwZoNcFRG43ZPe+kTXK5uO2RK//hV1gOsCQQCx9HpYJ+Yoif8OmoRRVpQ1KBXHYOG/BIwbRSdau2DWV2jmABR3YD7sRWvfmIvygrb/QLAcMNFBQU2sWfASd+1tAkBLg5Wq4VSd/QjJ75jEpD8+jTYprmlzwAI7MM8cv1u/KnCEDKGX6l2pQSxypCsNWeZfPmxqmPFKX0Re/h/iZhMFAkA9y63oiwJrtW/yvEmSjUQuKVtWvxflY0jb92mxIjyAch4lMIXq5mszVPAe1zRR5H5zqRz+zRz9UhYM8bZiU28JAkEAlToMMyTDX6zWvqrQuTsFc64GREoxvl6YyLYcx/UCNmTkZTmDbYW0CKwSxlNB+oh5vMWAOWhgoqXQyUATm/SQ8w=='

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return encryptor.encrypt(txt)
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey)
  return encryptor.decrypt(txt)
}

